import { useEffect, useImperativeHandle, useRef } from "react";

import BasicChartSearchMenu from "./BasicChartSearchMenu";
import { GetFieldDefsFromList } from "@/Utils/DataLib";
import { useChartDocumentContext } from "@/providers/ChartDocumentProvider";
import { useWSMgrContext } from "@/providers/WsMgrProvider";

const BasicTableSearchInput = ({
  onSearchResult,
  launchFullResults,
  projectFields,
  holderFields = undefined,
  useProjectFieldDefs = false,
  onSearchLoading = isLoading => {},
  processFullResult,
  autoFocus = true,
  ...props
}) => {
  const wsMgrContext = useWSMgrContext();
  const wsMgr = wsMgrContext.wsMgr.state;
  const { chartDocument } = useChartDocumentContext();
  const doc = wsMgr?.GetDoc();

  const ctrlRef = useRef();
  useImperativeHandle(props.ctrlRef, () => ctrlRef.current);

  const projectFieldNames = GetFieldDefsFromList(projectFields, useProjectFieldDefs).map(item =>
    item.GetFieldName()
  );
  const holderFieldNames = GetFieldDefsFromList(holderFields, useProjectFieldDefs).map(item =>
    item.GetFieldName()
  );

  if (!wsMgr || projectFieldNames.length === 0) {
    return null;
  }

  const isPositionDoc = doc?.IsPositionDocument();

  return (
    <span className={"ocn-basic-search-wrapper"} style={{ width: "428px", marginLeft: 0 }}>
      <BasicChartSearchMenu
        ctrlRef={ctrlRef}
        launchFull={launchFullResults}
        inputOnly
        inputProps={{ autoFocus }}
        onSearchResult={onSearchResult}
        processFullResult={processFullResult}
        projectFields={projectFieldNames}
        holderFields={holderFieldNames}
        disabled={props.disabled}
        placeholder={props.placeholder}
        onResetInput={props.onResetInput}
        searchProps={{ leftIcon: true, ...props.searchProps }}
        dataTestId={props.dataTestId}
        queryChartId={props.queryChartId}
        queryOptions={props.queryOptions}
        disableRefetchOnFocus={props.disableRefetchOnFocus}
        onLoading={onSearchLoading}
        isPositionChart={isPositionDoc}
      />
    </span>
  );
};

export default BasicTableSearchInput;
